<div mat-dialog-title class="app-modal-title pl-4 pr-4 pt-2 pb-2" [ngClass]="data.isSuccess ? 'info' : 'error'">
  @if (!data.isSuccess) {
    <mat-icon class="matIconHeader">error_outline</mat-icon>
  }
  <span>{{ data.headerText }}</span>
</div>

<div mat-dialog-content class="mat-dialog-content center mt-2">
  <mat-icon [ngClass]="data.isSuccess ? 'success' : 'error'">
    {{ data.isSuccess ? 'check' : 'error' }}
  </mat-icon>
  <span [innerHtml]="data.bodyText | ezSafeHtml"></span>
</div>
<mat-dialog-actions align="center">
  <button mat-flat-button color="primary" (click)="close()">{{ data.buttonText }}</button>
</mat-dialog-actions>
